import React, { useMemo } from "react";
import TableContainer1 from "../../../Components/Common/DataTables/TableContainer1";
import ImageComponent from "../../../Components/Common/DataTables/ImageComponent";
import ErrorBoundary from "../../../Components/Common/ErrorBoundary";
import useCustomer from "../../../hooks/useCustomer";
import { useParams } from "react-router-dom";
const CustomerCart = ({ custid }) => {

  const { getCartListApi } = useCustomer()
  const { isLoading, data } = getCartListApi(custid)

  const columns = useMemo(
    () => [

      {
        header: "Product Title",
        accessorKey: "title",
        enableSorting: true,
        enableColumnFilter: false,
        cell: ({ row }) => {
          return (
            <div style={{ width: 250 }}>{row.original.title}</div>
          );
        },
      },
      {
        header: "Price",
        accessorKey: "selling_price",
        enableSorting: true,
        enableColumnFilter: false,
      },

      {
        header: "Quantity",
        accessorKey: "count",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: "Date & Time",
        accessorKey: "created_at",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: "Country",
        accessorKey: "country_name",
        enableSorting: true,
        enableColumnFilter: false,
      },

    ],
    []
  );
  return (
    <>
      <ErrorBoundary fallback={<div>Oops! Something went wrong </div>}>
        <TableContainer1
          columns={(columns || [])}
          data={(!isLoading ? data != undefined ? data?.data?.result: [] : [] || [])}
          customPageSize={process.env.REACT_APP_PER_PAGE}
          total={!isLoading && data?.data.total}
          SearchPlaceholder='Search...'
        />
      </ErrorBoundary>
    </>

  );
};

export default React.memo(CustomerCart);
